export const CREATE_APP_DATA_METAFIELD_MUTATION = /* GraphQL */ `
    mutation CreateAppDataMetafield($metafieldsSetInput: [MetafieldsSetInput!]!) {
        metafieldsSet(metafields: $metafieldsSetInput) {
            metafields {
                id
                namespace
                key
                value
            }
            userErrors {
                field
                message
            }
        }
    }
`;

export interface MetafieldsSetInput {
    namespace: string;
    key: string;
    type: string;
    value: string;
    ownerId: string;
}

export interface MetafieldsSetMetafield {
    id: string;
    namespace: string;
    key: string;
    value: string;
}

export interface CreateAppDataMetafieldResponse {
    metafieldsSet: {
        metafields: MetafieldsSetMetafield[];
        userErrors: { field: string; message: string }[];
    };
}
